module.exports = __webpack_public_path__ + "static/img/cocina_04.d7348c1b.jpeg";